import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/react/react/docs/node_modules/@primer/gatsby-theme-doctocat/src/components/layout.js";
import { Avatar, Box } from '@primer/react';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const PropsTable = makeShortcode("PropsTable");
const PropsTableRow = makeShortcode("PropsTableRow");
const PropsTableSxRow = makeShortcode("PropsTableSxRow");
const ComponentChecklist = makeShortcode("ComponentChecklist");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`import {Avatar} from '@primer/react'
`}</code></pre>
    <h2>{`Examples`}</h2>
    <h3>{`Default`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live",
        "live": true
      }}>{`<Avatar src="https://avatars.githubusercontent.com/primer" />
`}</code></pre>
    <h3>{`Square`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live",
        "live": true
      }}>{`<Avatar square src="https://avatars.githubusercontent.com/primer" />
`}</code></pre>
    <h2>{`Props`}</h2>
    <h3>{`Avatar`}</h3>
    <PropsTable mdxType="PropsTable">
  <PropsTableRow name="src" type="string" required description="URL of the avatar image." mdxType="PropsTableRow" />{' '}
  <PropsTableRow name="alt" type="string" defaultValue="''" description="Provide alt text when the avatar is used without a name next to it." mdxType="PropsTableRow" />
  <PropsTableRow name="size" type="number" defaultValue="20" description="The size of the avatar in pixels." mdxType="PropsTableRow" />
  <PropsTableRow name="square" type="boolean" defaultValue="false" description="If true, the avatar will be square instead of circular." mdxType="PropsTableRow" />
  <PropsTableSxRow mdxType="PropsTableSxRow" />
    </PropsTable>
    <h2>{`Status`}</h2>
    <ComponentChecklist items={{
      propsDocumented: true,
      noUnnecessaryDeps: true,
      adaptsToThemes: true,
      adaptsToScreenSizes: true,
      fullTestCoverage: false,
      usedInProduction: true,
      usageExamplesDocumented: true,
      designReviewed: false,
      a11yReviewed: false,
      stableApi: false,
      addressedApiFeedback: false,
      hasDesignGuidelines: false,
      hasFigmaComponent: false
    }} mdxType="ComponentChecklist" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      